// Module
var code = `<condition ng-if="\$ctrl.propertyDefinition.type === \$ctrl.type"
           conditions="\$ctrl.conditions"
           property="\$ctrl.propertyDefinition.property">
  <div class="condition-container">
    {{\$ctrl.propertyDefinition.label}}

    <select ng-model="\$ctrl.model.param1"
            required
            ng-change="\$ctrl.valueChanged()"
            ng-options="option.id as option.label for option in \$ctrl.options1">
    </select>
    <multiselect items="\$ctrl.options2ForSelection"
                 ng-model="\$ctrl.model.param2"
                 label-property="'label'"
                 value-property="'id'"
                 select-all-option="true"
                 ng-disabled="!\$ctrl.model.param1"
                 ng-required="true">
    </multiselect>
  </div>
</condition>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/risk-profiling/conditions/double-select-condition.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;